import React from "react";
import { ErrorTemplate } from "components/ErrorTemplate";
import { NotFoundError } from "helpers/Consts";
import { useTitleChange } from "hooks/useTitleChange";
export const NotFound = () => {
  useTitleChange();
  return <ErrorTemplate {...NotFoundError} />;
};
